import { render } from "./Detail.vue?vue&type=template&id=2ae17eba&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import "./Detail.vue?vue&type=style&index=0&id=2ae17eba&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2ae17eba"

export default script